import { NgModule } from '@angular/core';
import { CommonModule, DatePipe } from '@angular/common';
import { SearchfilterPipe } from './pipes/searchfilter.pipe';
import { StripHtmlPipe } from './pipes/strip-html.pipe';
import { SlugifyPipe } from './pipes/slugify.pipe';
import { UserPhotoPipe } from './pipes/user-photo.pipe';
import { PhotoPipe } from './pipes/photo.pipe';
import { SafeUrlPipe } from './pipes/safe-url.pipe';
import { AssetPipe } from './pipes/asset.pipe';
import { CurrencyTypePipe } from './pipes/currencyType.pipe';
import { CompanyPhotoPipe } from './pipes/company-photo.pipe';
import { TrustHtmlPipe } from './pipes/trustHtml.pipe';
import { CurruncyFixedPipe } from './pipes/curruncyFixed.pipe';

@NgModule({
  declarations: [
    SearchfilterPipe,
    StripHtmlPipe,
    SlugifyPipe,
    UserPhotoPipe,
    PhotoPipe,
    SafeUrlPipe,
    AssetPipe,
    CurrencyTypePipe,
    CurruncyFixedPipe,
    CompanyPhotoPipe,
    TrustHtmlPipe
  ],
  imports: [
    CommonModule
  ],
  exports: [
    SearchfilterPipe,
    StripHtmlPipe,
    SlugifyPipe,
    DatePipe,
    UserPhotoPipe,
    PhotoPipe,
    SafeUrlPipe,
    AssetPipe,
    CurrencyTypePipe,
    CurruncyFixedPipe,
    CompanyPhotoPipe,
    TrustHtmlPipe
  ]
})
export class SharedPipesModule { }
